export const constants = {
  TINA_ASSETS_STRING_IN_URL: 'https://assets.tina.io',
};
